import React from 'react';

import { postAddTagAction } from 'actions/addPost';
import { connect } from 'react-redux';
import { selectTagRecommendations } from 'selectors/addPost';
import styled from 'styled-components';
import { StyledTypography, StyledButton } from 'styles/common';

// export function useTagRecommendations(){

// }

export default function TagRecommendations({ tagRecommendations, addTag }) {
  return tagRecommendations.map((tag) => (
    <TagDisplay
      rightGutter={1}
      variant="outlined"
      size="small"
      color="primary"
      onClick={() => addTag && addTag(tag)}
      key={`tagRecommendations${tag.id || tag.uuid}`}
    >
      <StyledTypography variant="caption">#{tag.name}</StyledTypography>
    </TagDisplay>
  ));
}

const mapStateToProps = (state, ownProps) => ({
  tagRecommendations: selectTagRecommendations(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addTag: (tag) => {
    dispatch(postAddTagAction(tag));
  },
});

export const TagRecommendationsContainer = connect(mapStateToProps, mapDispatchToProps)(TagRecommendations);

// export function TagRecommendationsContainer() {
//   const tagRecommendations = useSelector(selectTagRecommendations, shallowEqual);
//   const dispatch = useDispatch();
//   function addTag(tag) {
//     dispatch(postAddTagAction(tag));
//   }
//   return (
//     tagRecommendations && (
//       <TagRecommendations tagRecommendations={tagRecommendations} addTag={addTag} />
//     )
//   );
// }

const TagDisplay = styled(StyledButton)`
  border-radius: 20px;
  min-width: 32px;
  padding: 2px 8px;
`;
